// StyledSubmitButton.js
import styled from "styled-components";

const StyledSubmitButton = styled.button`
  margin-top: ${(props) => props.theme.submitMarginTop}px;
  font-size: ${(props) => props.theme.submitFontSize}px;
  font-family: ${(props) => props.theme.submitFontFamily};
  width: ${(props) => `${props.theme.submitWidth}${props.theme.submitWidthUnits}`};
  height: ${(props) => props.theme.submitHeight}px;
  border-radius: ${(props) => props.theme.submitBorderRadius}px;
  border-width: ${(props) => props.theme.submitBorderWidth}px;
  border-color: ${(props) => props.theme.submitBorderColor};
  border-style: solid;
  color: ${(props) => props.theme.submitColor};
  text-align: ${(props) => props.theme.submitTextAlign};
  transition: ${(props) => props.theme.transitionMain};
  font-weight: ${(props) => props.theme.submitFontWeight};
  background: ${(props) => `${props.theme.submitBackground} url('${props.theme.submitBackgroundImage}') no-repeat right ${props.theme.submitBackgroundImagePositionRight}px center`};
  background-size: ${(props) => props.theme.submitBackgroundImageSize}px;

  &:hover {
    background-color: ${(props) => props.theme.submitBackgroundHover};
    color: ${(props) => props.theme.submitColorHover};
    border-color: ${(props) => props.theme.submitBorderColorHover};
  }
`;

export default StyledSubmitButton;
